export function getCustomApiTemplate(name) {
  const template = {
    name,
    desc: '',
    dbMethod: '',
    required: false,
    custom: true,
    request: {},
    response: {}
  };
  return template;
}
export const customApiPrefix = 'custom_';
//# sourceMappingURL=custom.js.map
